import { yupResolver } from '@hookform/resolvers/yup'
import { TaskInput } from '@lib/api'
import { useI18n } from '@lib/i18n'
import { AssetWithResponse, getRemoteFormDefinition } from '@lib/validation'
import { AssetTypeEnum } from '@vetahealth/tuna-can-api'
import { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { View } from 'react-native'
import { Actions } from './Actions'
import { DatoAssets } from './Assets'
import { Header } from './Header'

export function Content({
  content,
  formDefinition,
  hideActions = false,
  readOnly = false,
  submit,
}: {
  content: { title?: string; assets: AssetWithResponse[] }
  formDefinition?: ReturnType<typeof getRemoteFormDefinition>
  hideActions?: boolean
  readOnly?: boolean
  submit?: (response: TaskInput) => Promise<void>
}) {
  const interpolateText = useI18n()

  const {
    handleSubmit,
    control,
    formState: { isLoading },
    reset,
  } = useForm({
    ...(formDefinition && {
      resolver: yupResolver(formDefinition.validationSchema),
      defaultValues: formDefinition.initialValues,
    }),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    disabled: readOnly,
  })

  const handleFormSubmit = useCallback(() => {
    handleSubmit(async (values: TaskInput): Promise<void> => {
      if (submit) await submit(values)
    })()
  }, [submit])

  useEffect(() => {
    reset(formDefinition?.initialValues)
  }, [content])

  return (
    <View>
      {!!content.title && <Header title={interpolateText(content.title)} />}

      <DatoAssets assets={content.assets} control={control} readOnly={readOnly} />

      {!hideActions && (
        <Actions
          hasQuestions={content.assets.some(({ type }) => type === AssetTypeEnum.Question)}
          onSubmit={handleFormSubmit}
          isSubmitLoading={isLoading}
        />
      )}
    </View>
  )
}
